import styles from './style.module.css';
import {Spinner} from 'reactstrap';
import Button from '@components/Forms/Button';
import {useState} from 'react';
import {useTranslation} from 'next-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import RequiresRegistrationModal from '@components/RequiresRegistrationModal';
interface RequiresRegistrationOverlayProps {
  verifying?: boolean;
  identifier: number;
  fixed?: boolean;
  pageUrl?: string;
}
export default function RequiresRegistrationOverlay(
  props: RequiresRegistrationOverlayProps
) {
  const {verifying, identifier, fixed, pageUrl} = props;
  const [openRegModal, setOpenRegModal] = useState(false);
  const [hide, setHide] = useState(false);
  const {t} = useTranslation('common');
  return (
    <div className={styles.container}>
      <RequiresRegistrationModal
        identifier={identifier}
        isOpen={openRegModal}
        toggleModal={() => setOpenRegModal(false)}
        pageUrl={pageUrl}
      />
      <div className={styles.content}>
        {verifying ? (
          <div className={'text-center'}>
            <Spinner />
          </div>
        ) : (
          !hide && (
            <div className={`${styles.dialog} ${fixed && styles.fixed}`}>
              {/*<button*/}
              {/*  className={styles.closeButton}*/}
              {/*  onClick={() => setHide(true)}*/}
              {/*>*/}
              {/*  <FontAwesomeIcon icon={faTimes} />*/}
              {/*</button>*/}
              <p>{t<string>('requires_registration_text')}</p>
              <div className="col-12 d-flex mt-3 justify-content-center">
                <Button onClick={() => setOpenRegModal(true)}>
                  {t<string>('cms_registration_form.register_button')}
                </Button>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
}
